import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import FormCreateAccountingUserFooter from './FormCreateAccountingUserFooter';
import FormCreateAccountingUserHeader from './FormCreateAccountingUserHeader';
import FormCreateAccountingUserBody from './FormCreateAccountingUserBody';
import { AccountingUserStatusEnum, AccountingUserTypeEnum } from '@/enums';
import { FormLabelErrorMessage } from '@/components/forms';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { TCallbackForm } from '@/types';
import { IAccountingUser } from '@/interfaces';
import { TFormData } from '.';
import dayjs from 'dayjs';

type TProps = {
    callback?: TCallbackForm<IAccountingUser>;
    accountingUser?: IAccountingUser;
    readonly?: boolean;
    onSubmit?: (data: TFormData) => Promise<void>;
};

const VARIABLES = {
    formConfig: {
        ...DEFAULT_FORM_CONFIG,
        defaultValues: {
            status: AccountingUserStatusEnum.ACTIVE,
            type: AccountingUserTypeEnum.EMPLOYEE,
            name: '',
            role: ''
        }
    } as UseFormProps<TFormData>
};

const FormCreateAccountingUser = ({ accountingUser, callback, readonly = false, onSubmit }: TProps) => {

    const formMethods = useForm<TFormData>({
        ...VARIABLES.formConfig,
        values: {
            ...VARIABLES.formConfig.defaultValues,
            ...accountingUser,
            startedAt: accountingUser?.startedAt ? dayjs(accountingUser.startedAt).format('YYYY-MM-DD') : undefined,
            disabledAt: accountingUser?.disabledAt ? dayjs(accountingUser.disabledAt).format('YYYY-MM-DD') : undefined,
            callback,
            readonly
        } as TFormData
    });
    const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

    return (
        <FormProvider {...formMethods}>
            <FormCreateAccountingUserHeader />
            <FormCreateAccountingUserBody isEditMode={!!accountingUser?._id} />
            <FormLabelErrorMessage errorMessage={errorMessage} />
            <FormCreateAccountingUserFooter onSubmit={onSubmit} />
        </FormProvider>
    );

};

export default FormCreateAccountingUser;
